module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Regular-6fcb706e40dea96b942e2f56f505fd12.svg";